export default "__VITE_ASSET__B0AG6T7K__"